import React, {createContext, useContext, useEffect, useState} from 'react';
import {InboxContext} from "./InboxProvider";

interface ModalContextType {
  modal: React.ReactNode;
  openModal: (content: React.ReactNode) => void;
  closeModal: () => void;
  isOpen: boolean;
}

export const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({ children }: {children: React.ReactNode}) => {
  const [modal, setModal] = useState<React.ReactNode>(null);
  const [isOpen, setOpen] = useState(false);
  const openModal = (content:React.ReactNode) => {
    setModal(content);
    setOpen(true);
  }
  const closeModal = () => {
    setOpen(false);
    setModal(null);
  }
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  return (
    <ModalContext.Provider value={{ modal, openModal, closeModal, isOpen }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModalContext must be used within a UserProvider');
  }
  return context;
};

